var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { class: _vm.listCounterClasses },
    _vm._l(_vm.listData.counters, function(counter) {
      return _c("li", [
        _c("p", { staticClass: "text-medium white mg mg--b-1" }, [
          _vm._v(" " + _vm._s(counter.number))
        ]),
        _c("p", { staticClass: "text-small white" }, [
          _vm._v(" " + _vm._s(counter.text))
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }